import {
  get,
  post,
  error,
} from '@/api/common.js'

function getNews(path, that) {
  get(path).then(function(Response) {
    that.total = Response.data.total;
    that.tableData = Response.data.list;
    that.currentPage = Response.data.page;
  }, function(Response) {
    error(Response);
  });
}

function getNewsDesc(path, that) {
  get(path).then(function(Response) {
    var title = Response.data.title;
    var temp = "<p>" + Response.data.content.replace(/\n/g, "</p><p>") + "</p>";
    that.content = "<h1 style='text-align:center;'>" + title + "</h1>" + temp;
  }, function(Response) {
    error(Response);
  });
}

export {
  getNews,
  getNewsDesc,
}



// WEBPACK FOOTER //
// ./src/api/news.js